module.exports = __webpack_public_path__ + "img/family_bg1.e4b7bd16.png";